module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("学生管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("句子翻译")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 80,
      "show-message": false
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('Col', {
    attrs: {
      "xs": 12,
      "sm": 8,
      "md": 6
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "原句："
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "支持模糊搜索",
      "clearable": ""
    },
    model: {
      value: (_vm.queryParam.sentence),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "sentence", $$v)
      },
      expression: "queryParam.sentence"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 12,
      "sm": 8,
      "md": 6
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "状态："
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    model: {
      value: (_vm.queryParam.status),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "status", $$v)
      },
      expression: "queryParam.status"
    }
  }, [_c('Option', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("启用")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 0
    }
  }, [_vm._v("停用")])], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 12,
      "sm": 8,
      "md": 6
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "type": "primary",
      "icon": "plus"
    },
    on: {
      "click": function($event) {
        return _vm.openModal()
      }
    }
  }, [_vm._v("新增")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('List', {
    ref: "dataList",
    attrs: {
      "tableColumns": _vm.title,
      "reload": _vm.reload,
      "listUrl": "/sentenceCard/list",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading
    }
  }), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": _vm.formData.id ? '编辑句子' : '新增句子',
      "width": "640",
      "mask-closable": false
    },
    model: {
      value: (_vm.showModal),
      callback: function($$v) {
        _vm.showModal = $$v
      },
      expression: "showModal"
    }
  }, [_c('Form', {
    ref: "editForm",
    attrs: {
      "label-width": 100,
      "model": _vm.formData,
      "rules": _vm.formRules
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "原句",
      "prop": "sentence"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 3,
      "placeholder": "请输入原句"
    },
    model: {
      value: (_vm.formData.sentence),
      callback: function($$v) {
        _vm.$set(_vm.formData, "sentence", $$v)
      },
      expression: "formData.sentence"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "中文翻译",
      "prop": "cnTranslate"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 3,
      "placeholder": "请输入中文翻译"
    },
    model: {
      value: (_vm.formData.cnTranslate),
      callback: function($$v) {
        _vm.$set(_vm.formData, "cnTranslate", $$v)
      },
      expression: "formData.cnTranslate"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "音频",
      "prop": "audioUrl"
    }
  }, [_c('FileUpload', {
    attrs: {
      "defaultFileList": _vm.defaultFileList,
      "num": 1,
      "text": "点击或拖拽上传音频"
    },
    on: {
      "on-file-change": _vm.onFileChange
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "状态"
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "160px"
    },
    model: {
      value: (_vm.formData.status),
      callback: function($$v) {
        _vm.$set(_vm.formData, "status", $$v)
      },
      expression: "formData.status"
    }
  }, [_c('Option', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("启用")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 0
    }
  }, [_vm._v("停用")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.showModal = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.saveLoading
    },
    on: {
      "click": _vm.onSave
    }
  }, [_vm._v("保存")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f7afac3c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/SentenceCardList.vue
// module id = 1987
// module chunks = 8